class ZerokitSpecs {
    constructor(root) {
        this.root = root;

        this.tabs = Array.from(
            root.querySelectorAll('[data-zk-specs-tab]')
        );

        this.panels = Array.from(
            root.querySelectorAll('[data-zk-specs-panel]')
        );

        if (!this.tabs.length || !this.panels.length) {
            return;
        }

        this.bindEvents();
    }


    /* ==========================================================================
       Events
       ========================================================================== */

    bindEvents() {
        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                this.activate(index);
            });

            tab.addEventListener('keydown', (event) => {
                this.handleKeyboard(event, index);
            });
        });
    }


    /* ==========================================================================
       Activate Panel
       ========================================================================== */

    activate(index, focus = false) {
        const selectedTab = this.tabs[index];

        if (!selectedTab) {
            return;
        }

        const targetId =
            selectedTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
            const active = tab === selectedTab;

            tab.classList.toggle(
                'is-active',
                active
            );

            tab.setAttribute(
                'aria-selected',
                active ? 'true' : 'false'
            );

            tab.setAttribute(
                'tabindex',
                active ? '0' : '-1'
            );
        });

        this.panels.forEach((panel) => {
            const active = panel.id === targetId;

            panel.classList.toggle(
                'is-active',
                active
            );

            panel.hidden = !active;
        });

        if (focus) {
            selectedTab.focus();
        }
    }


    /* ==========================================================================
       Keyboard Navigation
       ========================================================================== */

    handleKeyboard(event, index) {
        let nextIndex = null;

        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                nextIndex =
                    (index + 1) % this.tabs.length;
                break;

            case 'ArrowLeft':
            case 'ArrowUp':
                nextIndex =
                    (index - 1 + this.tabs.length) %
                    this.tabs.length;
                break;

            case 'Home':
                nextIndex = 0;
                break;

            case 'End':
                nextIndex =
                    this.tabs.length - 1;
                break;

            default:
                return;
        }

        event.preventDefault();

        this.activate(
            nextIndex,
            true
        );
    }
}


/* ==========================================================================
   Initialization
   ========================================================================== */

const zerokitSpecsInstances =
    new WeakMap();

function initZerokitSpecs(scope = document) {
    const sections =
        scope.matches?.('[data-zk-specs]')
            ? [scope]
            : Array.from(
                scope.querySelectorAll?.(
                    '[data-zk-specs]'
                ) || []
            );

    sections.forEach((section) => {
        if (zerokitSpecsInstances.has(section)) {
            return;
        }

        zerokitSpecsInstances.set(
            section,
            new ZerokitSpecs(section)
        );
    });
}


if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        () => {
            initZerokitSpecs();
        }
    );
} else {
    initZerokitSpecs();
}


/* ==========================================================================
   Shopify Theme Editor
   ========================================================================== */

document.addEventListener(
    'shopify:section:load',
    (event) => {
        initZerokitSpecs(event.target);
    }
);

document.addEventListener(
    'shopify:block:select',
    (event) => {
        const tab =
            event.target.closest?.(
                '[data-zk-specs-tab]'
            );

        if (!tab) {
            return;
        }

        const section =
            tab.closest('[data-zk-specs]');

        if (!section) {
            return;
        }

        const instance =
            zerokitSpecsInstances.get(section);

        if (!instance) {
            return;
        }

        const index =
            instance.tabs.indexOf(tab);

        if (index === -1) {
            return;
        }

        instance.activate(index);
    }
);